// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__oAImm","options":"AnswerScale_options__x33qR","selected":"AnswerScale_selected__2dKo5"};